import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import PropTypes from 'prop-types';

const CustomFieldBooleanEditor = ({ value, handleCustomFieldValueChange }) => (
  <FormControlLabel
    control={(
      <Switch
        checked={value}
        onChange={() => handleCustomFieldValueChange(!value)}
      />
    )}

    label={value ? 'True' : 'False'}
  />
);

const { bool, func } = PropTypes;

CustomFieldBooleanEditor.propTypes = {
  value: bool,
  handleCustomFieldValueChange: func,
};

export default CustomFieldBooleanEditor;
